@if (readOnly === false && dataIsReadyToBeDisplayed) {
  <section [formGroup]="myForm">
    <div class="row">
      @for (control of formData?.controls; track control) {
        <div class="col-md-4 mb-2 form-group p-fluid">
          <label class="w-100"
            ><span class="super-compos-label-input">{{ control.label }}</span>
            @if (['text', 'password', 'email', 'search', 'tel', 'url'].includes(control.type)) {
              <input class="form-control mt-2" [type]="control.type" [formControlName]="control.name" [value]="control.value" />
            }
            @if (['integer', 'decimal'].includes(control.type)) {
              <input class="form-control mt-2" type="number" step=".01" [formControlName]="control.name" [value]="control.value" />
            }
            @if (control.type === 'checkbox') {
              <label class="containerc mb-0 mt-2">
                {{ control.description }}
                <input type="checkbox" [formControlName]="control.name" class="super-compos-input-text form-control" />
                <span class="checkmark chek-menu"></span>
              </label>
            }
            @if (control.type === 'date') {
              <p-calendar
                [firstDayOfWeek]="1"
                appendTo="body"
                [formControlName]="control.name"
                [showIcon]="true"
                [iconDisplay]="'input'"
                dateFormat="dd/mm/yy"
                name="DateDocument">
              </p-calendar>
            }
            @if (control.type === 'dropdown' && !this.isAdvancedSearch) {
              <p-dropdown
                styleClass="w-100 mt-2"
                [virtualScroll]="true"
                virtualScrollItemSize="30"
                appendTo="body"
                [options]="control.listItemsDropdown"
                [filter]="true"
                [showClear]="true"
                [placeholder]="'editCourrier.pleaseChooseAnOption' | translate"
                [formControlName]="control.name">
              </p-dropdown>
            }
            @if (control.type === 'dropdown' && this.isAdvancedSearch) {
              <p-multiSelect
                styleClass="w-100 mt-2"
                [virtualScroll]="true"
                virtualScrollItemSize="30"
                appendTo="body"
                [options]="control.listItemsDropdown"
                [filter]="true"
                [placeholder]="'editCourrier.pleaseChooseAnOption' | translate"
                [formControlName]="control.name"
                [selectedItemsLabel]="'editCourrier.xOptionsSelected' | translate">
              </p-multiSelect>
            }
          </label>
        </div>
      }
    </div>
    <div class="row">
      @for (control of formDataTextarea?.controls; track control) {
        <div class="col-md-6 mb-2 form-group p-fluid">
          <label class="w-100"
            ><span class="super-compos-label-input">{{ control.label }}</span>
            <textarea
              rows="5"
              cols="30"
              [placeholder]="'iScan.action.insertYourRemark' | translate"
              [formControlName]="control.name"
              class="super-compos-input-text form-control w-100 mt-2"
              pInputTextarea></textarea>
          </label>
        </div>
      }
    </div>
  </section>
}
@if (readOnly && dataIsReadyToBeDisplayedInReadonlyMode) {
  <section class="row">
    @for (natureData of formDataForReadonly; track natureData) {
      <div class="col-md-3">
        <span class="super-compos-label-input">{{ natureData?.name }}</span>
        @if (natureData.type === 'Text') {
          <p class="mt-2">{{ natureData?.textValue }}</p>
        }
        @if (natureData.type === 'Integer') {
          <p class="mt-2">{{ natureData?.numberValue }}</p>
        }
        @if (natureData.type === 'Decimal') {
          <p class="mt-2">{{ natureData?.decimalValue }}</p>
        }
        @if (natureData.type === 'Date') {
          <p class="mt-2">{{ natureData?.dateValue | momentFormat: 'DD/MM/YYYY' }}</p>
        }
        @if (natureData.type === 'Checkbox') {
          <p class="mt-2">
            @if (natureData?.numberValue) {
              <span>✅</span>
            }
            @if (!natureData?.numberValue) {
              <span>❌</span>
            }
          </p>
        }
        @if (natureData.type === 'Dropdown') {
          <p class="mt-2">{{ natureData?.dropdownValue }}</p>
        }
      </div>
    }
    @for (natureTextarea of formDataReadonlyTextarea; track natureTextarea) {
      <div class="col-6">
        <span class="super-compos-label-input">{{ natureTextarea.name }}</span>
        <p class="multiline mt-2">{{ natureTextarea?.textValue }}</p>
      </div>
    }
  </section>
}
